export default __webpack_public_path__ + "static/media/ic-check-circle.b218aabe.svg";